export default ({ redirect, route }) => {
  if (route.name.startsWith('register')) {
    redirect('https://app.athlyzer.com/#/register')
  }
}
